import { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Image, Button } from "react-bootstrap";
import RatingStar from "../../components/common/ratingStar/ratingStar";
import GreatNonProfit from "../../assests/images/get-badge/great-non-profit-white.webp";
import ScriptCodeBox from "../../components/common/scriptCodeBox";
import {
    TopBannerSection,
    GetBadgeSection,
    AddReviewSection,
    AddReviewTitle,
    AddReviewText,
    AddReviewBox,
    AddReViewCode,
    AddReviewBoxTitle,
    AddReviewBoxSmall,
    AddReviewRating,
    AddReviewImage,
    AddReviewContent,
    AddReviewContentText,
    RecentReviewsBox,
    RecentReviewsTitle,
    RecentReviewWrap,
    RecentReviewWrapTitle,
    RecentReviewWrapRating,
    RecentReviewWrapText,
    MoreReviewButton,
    RecentReviewsMain,
} from "./getBadge";

import {
    Title,
    WriteReviewSection,
    ReviewText,
    ReviewSearch,
    ReviewSerchBox,
    ReviewRightSection,
    LeftQuote,
    RightQuote,
    RightBanner,
    BannerBlueWrapper,
    BannerBlueTitle,
    BannerBlueText,
    BadgeSmallText,
} from "../../components/common/commonSubBanner/commonSubBannerStyle";

import ReviewImage from '../../assests/images/top-banner-image/get-badge-image.webp';
import QuoteIcon from "../../assests/images/quoteicon.svg";
import { useNavigate, useParams } from "react-router-dom";
import BadgeCheckBox from "../../components/common/badgeCheckBox";
import { useDispatch, useSelector } from "react-redux";
import { getBadgeHandler } from "../../redux/slices/donationCamp/getBadge-slice";
import { MESSAGE } from "../../utils/message";
import MetaComponent from "../../components/common/metaComponent";
import SearchBox from "../../components/common/searchBox/searchBox";

const GetBadge = () => {
    const navigate = useNavigate();
    const [color, setColor] = useState<string | number>('');
    const dispatch: any = useDispatch();
    const { id } = useParams();
    const getBadge = useSelector((state: any) => state?.getBadge?.data?.data)

    useEffect(() => {
        dispatch(getBadgeHandler());
    }, [])
    const scriptCode = `<script type="text/javascript"> gnp_url = 'universalgiving';gnp_num = '1'; </script> <script src="https://greatnonprofits.org/js/api/badge_simple.js" type="text/javascript"></script> <noscript> <a href="https://greatnonprofits.org/org/universalgiving/?badge=1"> <img alt="Review UniversalGivingÂ® on Great Nonprofits" title="Review UniversalGivingÂ® on Great Nonprofits" src="//cdn.greatnonprofits.org/images/great-nonprofits.gif?id=646"> </a></noscript>`;

    return (
        <>
            <MetaComponent
                keywords="nonprofits, non-profits, organization, dashboard"
                description="Organization Dashboard"
                ogTitle=""
                ogDescription="Organization Dashboard"
                ogUrl=""
                ogImage="https://static.wixstatic.com/media/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg/v1/fit/w_2500,h_1330,al_c/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg"
            />
            <>
                <TopBannerSection>

                    <WriteReviewSection>
                        <Container className="cont-w">
                            <Row>
                                <Col lg={6} sm={12} md={12} className="toprated test">
                                    <Title>Show Off Your Reviews</Title>

                                    <ReviewSearch className="review-search-group">
                                        <ReviewSerchBox>
                                            <SearchBox />
                                            {/* <Form className="search-header">
                                        <SearchInputBox>
                                        <InputGroup>
                                            <InputGroupIcon>
                                                <Image src={SearchIcon} width="20px" height="20px" className="search-group-icon" />
                                            </InputGroupIcon>
                                            <FormControl  type="text" placeholder="Org,City & State" id="location" maxLength={30} name="location"/>
                            
                                        </InputGroup>
                                        <InputGroup className="zipcode">
                                        <FormControl type="number" onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()} placeholder="Zip Code" maxLength={10} name="zipcode" />
                                        </InputGroup>
                                        </SearchInputBox>
                                        <Button variant="outline-success" type="submit">Search</Button>
                                    </Form> */}
                                        </ReviewSerchBox>
                                    </ReviewSearch>

                                    <BannerBlueWrapper className="blue-banner">
                                        <BannerBlueTitle>Contact GreatNonprofits</BannerBlueTitle>
                                        <BannerBlueText>Monday to Friday, 8am to 4pm PST</BannerBlueText>
                                    </BannerBlueWrapper>

                                    <BadgeSmallText className="base-small-text">Add a Logo Badge to Your Website</BadgeSmallText>
                                    <ReviewText className="base-text">Copy one of the code snippets below, then paste the code into your website wherever you would like your rating badge to appear.</ReviewText>
                                    <BadgeCheckBox setColor={setColor} />
                                </Col>
                                <Col lg={6} sm={12} md={12}>
                                    <RightBanner className="left_banner">
                                        <ReviewRightSection>
                                            <LeftQuote className="quote_col"><span><Image src={QuoteIcon} alt="QuoteIcon" /></span> I've worked in nonprofits for over 20 years, and having this tool now is a first for me. I'm really grateful for it.</LeftQuote>
                                            <Image src={ReviewImage} alt="ReviewImage" />
                                            <RightQuote className="quote_col"><span><Image src={QuoteIcon} alt="QuoteIcon" /></span> I've worked in nonprofits for over 20 years, and having this tool now is a first for me. I'm really grateful for it.</RightQuote>
                                        </ReviewRightSection>
                                    </RightBanner>
                                </Col>
                            </Row>
                        </Container>
                    </WriteReviewSection>

                </TopBannerSection>

                <GetBadgeSection>
                    <Container className="cont-w">
                        <Row>
                            <Col sm="12">
                                <ScriptCodeBox color={color} />
                            </Col>
                        </Row>
                    </Container>
                </GetBadgeSection>

                <AddReviewSection>
                    <Container className="cont-w">
                        <Row>
                            <Col sm="12">
                                <AddReviewTitle>{MESSAGE.addReviewBadge}</AddReviewTitle>
                                <AddReviewText>{MESSAGE.copyBadgeSnippet}</AddReviewText>
                            </Col>
                        </Row>

                        <Row>
                            <Col lg="4" md="12">
                                <AddReviewTitle>{MESSAGE.miniBadge}</AddReviewTitle>
                                <AddReviewBox>
                                    <AddReviewBoxTitle>
                                        <AddReviewBoxSmall>{getBadge?.campName}</AddReviewBoxSmall>
                                        {getBadge?.topRated} {MESSAGE.topRatedNonprofit}
                                    </AddReviewBoxTitle>

                                    <AddReviewRating>
                                        <RatingStar review={getBadge?.reviews} rating={getBadge?.rating} />
                                    </AddReviewRating>

                                    <AddReviewContent>
                                        <AddReviewContentText>{MESSAGE.reviewFrom}</AddReviewContentText>

                                        <AddReviewImage>
                                            <Image src={GreatNonProfit} alt="Great Non Profit" />
                                        </AddReviewImage>
                                    </AddReviewContent>

                                    <RecentReviewsTitle>{MESSAGE.recentReviews}</RecentReviewsTitle>

                                    {getBadge?.recentReviews.map((reviews: any, index: number) => (
                                        <RecentReviewsMain key={index + 1}>

                                            <RecentReviewsBox>
                                                <RecentReviewWrap>
                                                    <RecentReviewWrapTitle>{reviews?.name}</RecentReviewWrapTitle>
                                                    <RecentReviewWrapRating>
                                                        <RatingStar review={reviews?.reviews} rating={reviews?.rating} color="white" />
                                                    </RecentReviewWrapRating>
                                                </RecentReviewWrap>

                                                <RecentReviewWrapText>{reviews?.description}</RecentReviewWrapText>

                                            </RecentReviewsBox>

                                        </RecentReviewsMain>))}

                                    <MoreReviewButton>
                                        <Button className="btn-outline-success-blue" onClick={() => navigate(`/org/${id}`)}>Read More Reviews</Button>
                                    </MoreReviewButton>

                                </AddReviewBox>

                            </Col>
                            <Col lg="8" md="12">
                                <AddReViewCode className="mini-badge-code">
                                    {scriptCode}
                                </AddReViewCode>
                            </Col>
                        </Row>

                    </Container>
                </AddReviewSection>

            </>
        </>

    );
}

export default GetBadge;